import { Grid, Modal, Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

import SvgClose from '@HomaHealth/ui-component-library/lib/_components/atoms/Icons/Close';
import PageUnderConstruction from '../../../../public/Images/PageUnderConstruction.png';
import NoAccess from '../../../../public/Images/NoAccess.png';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';

export interface FeatureAccessModalProps {
  open: boolean;
  handleClose: () => any;
  access: boolean;
}

const FeatureAccessModal: React.FC<FeatureAccessModalProps> = ({
  open,
  handleClose,
  access,
}) => {
  const useStyles = makeStyles()({
    hide: {
      display: 'none',
    },
    upperGrid: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '592px',
      height: '375px',
      padding: '24px 28px 40px 32px',
      backgroundColor: patientAccessTheme.palette.status.white,
      border: 'none !important',
      position: 'relative',
      outline: 'none',
    },
    subTitleParts: {
      whiteSpace: 'break-spaces',
      display: 'flex',
      textAlign: 'center',
    },
    paddingStyle: {
      paddingLeft: '30px',
    },
  });
  const { classes } = useStyles();
  const constants = componentConstants.ORGANISMS.FEATURE_MODAL;
  return (
    <Modal open={open} onClose={handleClose} className={classes.modal}>
      <Paper className={classes.paper}>
        <Grid
          className={classes.upperGrid}
          sx={{
            justifyContent: 'flex-end',
          }}
        >
          <SvgClose
            style={{ cursor: 'pointer' }}
            color={patientAccessTheme.palette.status.icon}
            onClick={handleClose}
          />
        </Grid>

        <Grid
          container
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          {access ? (
            <>
              <Grid>
                <img src={PageUnderConstruction} alt="PageUnderConstruction" />
              </Grid>
            </>
          ) : (
            <>
              <Grid>
                <img src={NoAccess} alt="NoAccess" />
              </Grid>
            </>
          )}

          <Grid style={{ marginTop: '25px' }}>
            <Typography
              fontSize="16px"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.highemphasis}
              fontType="semiBold"
            >
              {access ? constants.TITLE1 : constants.TITLE2}
            </Typography>
          </Grid>
          <Grid style={{ marginTop: '5px' }}>
            <Typography
              fontSize="14px"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {access ? constants.SUBTITLE1.PART1 : constants.SUBTITLE2.PART1}
            </Typography>

            {access ? (
              <Typography
                fontSize="14px"
                lineHeight="24px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
                align="center"
              >
                {constants.SUBTITLE1.PART2}
              </Typography>
            ) : (
              <>
                <div className={classes.subTitleParts}>
                  <Typography
                    fontSize="14px"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    className={classes.paddingStyle}
                  >
                    {constants.SUBTITLE2.PART2}
                  </Typography>
                  <Typography
                    fontSize="14px"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.primary.main}
                  >
                    {constants.SUBTITLE2.PART3}
                  </Typography>
                  <Typography
                    fontSize="14px"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                  >
                    {constants.SUBTITLE2.PART4}
                  </Typography>
                </div>
              </>
            )}
          </Grid>
          <Grid style={{ marginTop: '20px' }}>
            <Button
              label={constants.GO_BACK}
              variant="contained"
              color="primary"
              height="36px"
              width="210px"
              borderRadius="4px"
              onClick={handleClose}
            />
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
};
export default FeatureAccessModal;
